function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var EmptyPanel = require('./empty-panel');
var SalesTableTemplate = require('./sales-table.template');
var CatalogFooterTemplate = require('./catalog-footer.template');
var _require = require('./browse-listings'),
  loadListingsPage = _require.loadListingsPage;
var _require2 = require('../categories'),
  DEFAULT_PAGE_SIZE = _require2.DEFAULT_PAGE_SIZE;
var SalesView = /*#__PURE__*/function () {
  function SalesView(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, SalesView);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.summaries = [];
    this.loading = false;
    this.loadToken = 0;
    this.page = 1;
    this.page_size = DEFAULT_PAGE_SIZE;
    this.pagination = null;
    this.empty = new EmptyPanel(app, mod, {
      title: 'No completed sales.',
      body: '',
      actionLabel: '',
      onAction: null
    });
  }
  return _createClass(SalesView, [{
    key: "render",
    value: function render() {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (container) {
        this.container = container;
      }
      if (!this.container) {
        return;
      }
      this.app.browser.replaceElementContentBySelector("\n    <div class=\"storefront-admin\">\n      <section class=\"catalog storefront-catalog\">\n        <div class=\"storefront-status\" data-sales-status ".concat(this.loading ? '' : 'hidden', " role=\"status\" aria-live=\"polite\">\n          ").concat(this.loading ? "<div class=\"saito-spinner\" aria-hidden=\"true\"></div>\n          <p>Loading sold listings\u2026</p>" : '', "\n        </div>\n        <div data-listings-table></div>\n        <div class=\"catalog-footer\" data-catalog-footer hidden></div>\n      </section>\n    </div>\n  "), this.container);
      if (this.loading) {
        return;
      }
      this.renderResults();
    }

    /**
     * @param {import('../summary')[]|null} [summaries] Preloaded sold summaries (no extra fetch).
     */
  }, {
    key: "show",
    value: function () {
      var _show = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var summaries,
          _args = arguments;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              summaries = _args.length > 0 && _args[0] !== undefined ? _args[0] : null;
              if (!Array.isArray(summaries)) {
                _context.n = 2;
                break;
              }
              this.summaries = summaries;
              this.pagination = {
                offset: 0,
                page: 1,
                page_size: summaries.length || this.page_size,
                total: summaries.length,
                total_pages: summaries.length ? 1 : 0,
                has_next: false,
                has_previous: false
              };
              this.page = 1;
              this.loading = false;
              _context.n = 1;
              return this.decryptSellerNotes(this.summaries);
            case 1:
              this.render();
              return _context.a(2);
            case 2:
              this.page = 1;
              _context.n = 3;
              return this.loadPage({
                page: 1
              });
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function show() {
        return _show.apply(this, arguments);
      }
      return show;
    }()
  }, {
    key: "decryptSellerNotes",
    value: function () {
      var _decryptSellerNotes = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var summaries,
          private_key,
          _iterator,
          _step,
          summary,
          ciphertext,
          buyer,
          shared_secret,
          plain,
          _args2 = arguments,
          _t,
          _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              summaries = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : [];
              private_key = '';
              _context2.p = 1;
              _context2.n = 2;
              return this.app.wallet.getPrivateKey();
            case 2:
              private_key = _context2.v;
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
              console.warn('Store: seller private key unavailable for note decrypt', (_t === null || _t === void 0 ? void 0 : _t.message) || _t);
            case 4:
              _iterator = _createForOfIteratorHelper(summaries || []);
              _context2.p = 5;
              _iterator.s();
            case 6:
              if ((_step = _iterator.n()).done) {
                _context2.n = 9;
                break;
              }
              summary = _step.value;
              summary.seller_note = '';
              ciphertext = String(summary.note || '').trim();
              buyer = String(summary.buyer || '').trim();
              if (!(!ciphertext || !buyer || !private_key)) {
                _context2.n = 7;
                break;
              }
              return _context2.a(3, 8);
            case 7:
              try {
                shared_secret = this.app.crypto.generateSharedSecret(private_key, buyer);
                plain = this.app.crypto.aesDecrypt(ciphertext, shared_secret);
                if (plain) {
                  summary.seller_note = plain;
                }
              } catch (err) {
                console.warn('Store: seller note decrypt failed', (err === null || err === void 0 ? void 0 : err.message) || err);
              }
            case 8:
              _context2.n = 6;
              break;
            case 9:
              _context2.n = 11;
              break;
            case 10:
              _context2.p = 10;
              _t2 = _context2.v;
              _iterator.e(_t2);
            case 11:
              _context2.p = 11;
              _iterator.f();
              return _context2.f(11);
            case 12:
              return _context2.a(2);
          }
        }, _callee2, this, [[5, 10, 11, 12], [1, 3]]);
      }));
      function decryptSellerNotes() {
        return _decryptSellerNotes.apply(this, arguments);
      }
      return decryptSellerNotes;
    }()
  }, {
    key: "loadPage",
    value: function () {
      var _loadPage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _ref,
          _ref$page,
          page,
          seller,
          next_page,
          offset,
          token,
          _this$pagination,
          result,
          _args3 = arguments,
          _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _ref = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {}, _ref$page = _ref.page, page = _ref$page === void 0 ? this.page : _ref$page;
              seller = String(this.mod.publicKey || '').trim();
              if (seller) {
                _context3.n = 1;
                break;
              }
              this.summaries = [];
              this.pagination = {
                offset: 0,
                page: 1,
                page_size: this.page_size,
                total: 0,
                total_pages: 0,
                has_next: false,
                has_previous: false
              };
              this.loading = false;
              this.render();
              return _context3.a(2);
            case 1:
              next_page = Math.max(1, Number(page) || 1);
              offset = (next_page - 1) * this.page_size;
              this.page = next_page;
              this.loading = true;
              token = ++this.loadToken;
              this.render();
              _context3.p = 2;
              _context3.n = 3;
              return loadListingsPage(this.app, this.mod, {
                public_key: seller,
                category: '',
                offset: offset,
                page_size: this.page_size,
                status: 'sold'
              });
            case 3:
              result = _context3.v;
              if (!(token !== this.loadToken)) {
                _context3.n = 4;
                break;
              }
              return _context3.a(2);
            case 4:
              this.summaries = result.listings || [];
              this.pagination = result.pagination || null;
              this.page = ((_this$pagination = this.pagination) === null || _this$pagination === void 0 ? void 0 : _this$pagination.page) || this.page;
              _context3.n = 5;
              return this.decryptSellerNotes(this.summaries);
            case 5:
              _context3.n = 8;
              break;
            case 6:
              _context3.p = 6;
              _t3 = _context3.v;
              console.warn('Store: sold listings load failed', (_t3 === null || _t3 === void 0 ? void 0 : _t3.message) || _t3);
              if (!(token !== this.loadToken)) {
                _context3.n = 7;
                break;
              }
              return _context3.a(2);
            case 7:
              this.summaries = [];
              this.pagination = {
                offset: 0,
                page: 1,
                page_size: this.page_size,
                total: 0,
                total_pages: 0,
                has_next: false,
                has_previous: false
              };
            case 8:
              if (!(token !== this.loadToken)) {
                _context3.n = 9;
                break;
              }
              return _context3.a(2);
            case 9:
              this.loading = false;
              this.render();
            case 10:
              return _context3.a(2);
          }
        }, _callee3, this, [[2, 6]]);
      }));
      function loadPage() {
        return _loadPage.apply(this, arguments);
      }
      return loadPage;
    }()
  }, {
    key: "renderResults",
    value: function renderResults() {
      var _this$pagination$tota,
        _this$pagination2,
        _this = this;
      var status = document.querySelector("".concat(this.container, " [data-sales-status]"));
      if (status) {
        status.hidden = true;
        status.innerHTML = '';
      }
      var host = document.querySelector("".concat(this.container, " [data-listings-table]"));
      var footer = document.querySelector("".concat(this.container, " [data-catalog-footer]"));
      if (!host) {
        return;
      }
      var listings = this.summaries || [];
      var total = Number((_this$pagination$tota = (_this$pagination2 = this.pagination) === null || _this$pagination2 === void 0 ? void 0 : _this$pagination2.total) !== null && _this$pagination$tota !== void 0 ? _this$pagination$tota : listings.length);
      if (!total) {
        host.innerHTML = '<div class="storefront-empty"></div>';
        if (footer) {
          footer.hidden = true;
          footer.innerHTML = '';
        }
        this.empty.render("".concat(this.container, " .storefront-empty"));
        return;
      }
      host.innerHTML = SalesTableTemplate({
        listings: listings,
        caption: 'Sales'
      });
      this.attachBuyerCopyEvents(host);
      if (footer) {
        footer.hidden = false;
        footer.innerHTML = CatalogFooterTemplate({
          pagination: this.pagination,
          empty: false
        });
        CatalogFooterTemplate.attachCatalogFooterEvents(footer, {
          page: this.page,
          pagination: this.pagination,
          onPage: function onPage(nextPage) {
            return _this.loadPage({
              page: nextPage
            });
          }
        });
      }
    }
  }, {
    key: "attachBuyerCopyEvents",
    value: function attachBuyerCopyEvents(host) {
      if (!host) {
        return;
      }
      host.querySelectorAll('[data-action="copy-buyer"]').forEach(function (btn) {
        btn.onclick = /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(e) {
            var buyer, _navigator$clipboard, ta, _t4;
            return _regenerator().w(function (_context4) {
              while (1) switch (_context4.p = _context4.n) {
                case 0:
                  e.preventDefault();
                  e.stopPropagation();
                  buyer = String(btn.getAttribute('data-buyer') || '').trim();
                  if (buyer) {
                    _context4.n = 1;
                    break;
                  }
                  return _context4.a(2);
                case 1:
                  _context4.p = 1;
                  if (!((_navigator$clipboard = navigator.clipboard) !== null && _navigator$clipboard !== void 0 && _navigator$clipboard.writeText)) {
                    _context4.n = 3;
                    break;
                  }
                  _context4.n = 2;
                  return navigator.clipboard.writeText(buyer);
                case 2:
                  _context4.n = 4;
                  break;
                case 3:
                  ta = document.createElement('textarea');
                  ta.value = buyer;
                  document.body.appendChild(ta);
                  ta.select();
                  document.execCommand('copy');
                  ta.remove();
                case 4:
                  if (typeof siteMessage === 'function') {
                    siteMessage('Buyer address copied', 2000);
                  }
                  _context4.n = 6;
                  break;
                case 5:
                  _context4.p = 5;
                  _t4 = _context4.v;
                  console.warn('Store: copy buyer address failed', (_t4 === null || _t4 === void 0 ? void 0 : _t4.message) || _t4);
                case 6:
                  return _context4.a(2);
              }
            }, _callee4, null, [[1, 5]]);
          }));
          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }();
      });
    }
  }]);
}();
module.exports = SalesView;